import { definePreset } from '@primeuix/themes';
import Aura from '@primeuix/themes/aura';

/**
 * Quote Devil design-system preset.
 * Primary scale built around Quote Devil Red (#AB1C21); white contrast text.
 * Mirrors the preset used in Chill.QD.Cancellation.Angular.
 */
export const QuoteDevilPreset = definePreset(Aura, {
  semantic: {
    primary: {
      50: '#fbecec',
      100: '#f6d3d4',
      200: '#e8c9ca',
      300: '#dd9a9c',
      400: '#c85257',
      500: '#ab1c21',
      600: '#8f161a',
      700: '#731216',
      800: '#570d10',
      900: '#3b080a',
      950: '#250405',
    },
    colorScheme: {
      light: {
        primary: {
          color: '#ab1c21',
          contrastColor: '#ffffff',
          hoverColor: '#8f161a',
          activeColor: '#731216',
        },
        highlight: {
          background: '#fbecec',
          focusBackground: '#f6d3d4',
          color: '#3b080a',
          focusColor: '#3b080a',
        },
      },
    },
  },
});
